import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'
import TSelectForm from "../../common/TSelectForm";
import TInputForm from "../../common/TInputForm";
import If from "../../common/control/If";

class AdamForm extends Component {

    validate(setting) {
        return ((setting.adamType == "above" && setting.adamAdAbove)
            || (setting.adamType === 'below' && setting.adamAdBelow)
            || (setting.adamType === 'both' && setting.adamAdAbove && setting.adamAdBelow))
    }

    componentDidMount() {
        const { onChange, data } = this.props;

        // 2018년 9월 모바일 광고 사이즈 추가 전의 설정인 경우
        if (data.setting.adamType && data.setting.adamAd) {
            // adamAd -> AdamAdAbove 또는 AdamAdAbove 로 마이그레이션
            if (data.setting.adamType == "above") {
                onChange(
                    Object.assign({}, data, {
                        setting: {
                            adamType: "above",
                            adamAdAbove: data.setting.adamAd
                        },
                        validated: true
                    })
                )
            }
            else if (data.setting.adamType == "below") {
                onChange(
                    Object.assign({}, data, {
                        setting: {
                            adamType: "above",
                            adamAdBelow: data.setting.adamAd
                        },
                        validated: true
                    })
                )
            }

        }
        else {
            onChange(
                Object.assign({}, data, {
                    validated: this.validate(data.setting)
                })
            );
        }
    }

    @autobind
    handleAdamTypeChange(AdamType) {
        const { onChange } = this.props;
        const setting = Object.assign({},  this.props.data.setting, {
            adamType: AdamType
        });
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    @autobind
    handleADCodeChange(type, ADCode) {
        const { onChange } = this.props
        var newObject = Object();
        newObject[type] = ADCode;
        const setting = Object.assign({},  this.props.data.setting, newObject);
        onChange(
            Object.assign({},  this.props.data, {
                setting: setting,
                validated: this.validate(setting)
            })
        )
    }

    render() {
        const { plugin, data } = this.props;
        console.log(data);
        return (
            <div className="desc_plugin8">
                <p className="txt_plugin" dangerouslySetInnerHTML={{ __html: plugin.rawDescription }} />
                <div className="info_pluginline">
                    <strong className="tit_set">설정 방법</strong>
                    <ol className="list_plugin">
                        <li>
                            <span className="txt_em">1</span>
                            광고 배치 유형 중 1개를 선택해 주세요.(상단/하단 각각 1개씩 선택 가능)
                        </li>
                        <li>
                            <span className="txt_em">2</span>
                            광고 코드 입력창에 AdFit 광고 코드를 넣어주세요.<a href="http://adfit.biz.daum.net" target="_blank" className="link_other">AdFit 바로가기</a>
                        </li>
                        <li>
                            <span className="txt_em">3</span>
                            적용 버튼을 누르면 설정이 완료됩니다.
                        </li>
                    </ol>
                </div>
                <fieldset>
                    <legend className="tit_set">광고 형태</legend>
                    <div className="list_google">
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adamType == "above"} onChange={(e)=>this.handleAdamTypeChange('above')}/>
                            <span className="ico_google ico_google3">상단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adamType == "below"} onChange={(e)=>this.handleAdamTypeChange('below')}/>
                            <span className="ico_google ico_google5">하단 전체</span>
                        </label>
                        <label className="lab_google">
                            <input type="radio" name="plugin1" className="inp_set" checked={data.setting.adamType == "both"} onChange={(e)=>this.handleAdamTypeChange('both')}/>
                            <span className="ico_google ico_google8">상단, 하단 전체</span>
                        </label>
                    </div>
                    <If condition={data.setting.adamType == "both" || data.setting.adamType == "above"} >
                        <textarea className="tf_blog" title="광고 코드 입력"
                            placeholder="320X100, 320X50, 300X250 크기의 AdFit 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('adamAdAbove', e.target.value)} value={data.setting.adamAdAbove}></textarea>
                    </If>
                    <If condition={data.setting.adamType == "below" || data.setting.adamType == "both"} >
                        <textarea className="tf_blog" title="광고 코드 입력"
                                      placeholder="320X100, 320X50, 300X250 크기의 AdFit 광고 코드만 넣을 수 있습니다." onChange={(e)=>this.handleADCodeChange('adamAdBelow', e.target.value)} value={data.setting.adamAdBelow}></textarea>
                    </If>
                </fieldset>
                {this.props.saveButton()}
            </div>
        )
    }
}

AdamForm.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default AdamForm
